export const LOAN = 'LOAN';
export const LEASE = 'LEASE';
export const NO_PRICE_ITEMS = 'No prices were returned from vcda.';
export const OFFSET_HEIGHT = 66;
export const OFFSET_INTEGRATED_DR_HEIGHT = 33;
export const ASC = 'asc';
export const DESC = 'desc';
export const BUTTON_RESET_CLASSES = 'p-0 text-left bg-transparent border-0';



// WEBPACK FOOTER //
// ./src/constants/constants.js